import WaveSurfer from "wavesurfer.js";
import {
	getS3Link
} from "../apiFunction.js";

export default {
	name: "AnsweredCommuMixin",
	data() {
		return {
            isPlayingAudio: false,
			audioLinkVal: null,
			wavesurferWave: null,
			timerVal: null,
			elapsedMss: 0,
			finalRecordedMss: 0,
        }
    },
    created(){
        if(this.questionData){
            console.log('in ghfcxcfghb')
            this.checkAndGetAudio();
        }
        console.log('in createdddddddddddddddddddddd')
    },
    computed:{
        formattedTimeVal() {
            console.log(this.elapsedMss)
			const totalSec = Math.floor(this.elapsedMss / 1000);
			const m = String(Math.floor(totalSec / 60)).padStart(2, "0");
			const s = String(totalSec % 60).padStart(2, "0");
			return `${m}:${s}`;
		},
    },
    methods:{
        async loadSampleWaveData() {
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  const sampleRate = 44100;
  const duration = 2; // 2 seconds
  const length = sampleRate * duration;
  const buffer = audioCtx.createBuffer(1, length, sampleRate);
  const data = buffer.getChannelData(0);

  // Create a simple constant amplitude waveform for a dotted baseline
  const barCount = 50;
  const samplesPerBar = Math.floor(length / barCount);
  const constantHeight = 0.15;

  for (let bar = 0; bar < barCount; bar++) {
    for (let i = 0; i < samplesPerBar; i++) {
      const index = bar * samplesPerBar + i;
      // simple sine wave multiplied by constant height
      data[index] = constantHeight * Math.sin(i / 5);
    }
  }

  return new Promise((resolve) => {
    const numOfChan = buffer.numberOfChannels,
      totalLength = buffer.length * numOfChan * 2 + 44,
      arrayBuffer = new ArrayBuffer(totalLength),
      view = new DataView(arrayBuffer),
      sampleRate = buffer.sampleRate;

    let offset = 0;

    function writeString(str) {
      for (let i = 0; i < str.length; i++) {
        view.setUint8(offset++, str.charCodeAt(i));
      }
    }

    // WAV header
    writeString("RIFF");
    view.setUint32(offset, 36 + buffer.length * numOfChan * 2, true);
    offset += 4;
    writeString("WAVE");
    writeString("fmt ");
    view.setUint32(offset, 16, true);
    offset += 4;
    view.setUint16(offset, 1, true);
    offset += 2;
    view.setUint16(offset, numOfChan, true);
    offset += 2;
    view.setUint32(offset, sampleRate, true);
    offset += 4;
    view.setUint32(offset, sampleRate * numOfChan * 2, true);
    offset += 4;
    view.setUint16(offset, numOfChan * 2, true);
    offset += 2;
    view.setUint16(offset, 16, true);
    offset += 2;
    writeString("data");
    view.setUint32(offset, buffer.length * numOfChan * 2, true);
    offset += 4;

    // Write PCM samples interleaved
    let interleaved = new Float32Array(buffer.length * numOfChan);
    const channels = [];
    for (let i = 0; i < numOfChan; i++) {
      channels.push(buffer.getChannelData(i));
    }
    for (let i = 0; i < buffer.length; i++) {
      for (let ch = 0; ch < numOfChan; ch++) {
        interleaved[i * numOfChan + ch] = channels[ch][i];
      }
    }
    let pos = 44;
    for (let i = 0; i < interleaved.length; i++, pos += 2) {
      let sample = Math.max(-1, Math.min(1, interleaved[i]));
      view.setInt16(pos, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
    }

    resolve(new Blob([view], { type: "audio/wav" }));
  });
},
        async getAudioData(data){
            this.audioLinkVal = await this.getS3Link(data.answer.audioPath, "audio");
			this.elapsedMss = this.finalRecordedMss = data.answer.audioDurationInSec * 1000;
			this.initWaveSurferForS3(data);
        },
        stopTimerVal() {
			clearInterval(this.timerVal);
		},
		startTimerVal() {
			this.stopTimerVal();
			const start = Date.now() - this.elapsedMss;
			this.timerVal = setInterval(() => {
				if (this.isPlayingAudio) {
					this.elapsedMss = Date.now() - start;
				}
			}, 200);
		},
		async togglePlayAudio() {
			if (!this.wavesurferWave) return;

			// 🔹 CASE 1: Currently Playing → Pause both
			if (this.isPlayingAudio) {
				this.wavesurferWave.pause();
				this.isPlayingAudio = false;
				this.elapsedMss = this.wavesurferWave.getCurrentTime() * 1000;
				this.stopTimerVal();
				return;
			}

			// 🔹 CASE 2: Start Playing (both)
			this.isPlayingAudio = true;
			// this.elapsedMss = 0;
			const currentTime = this.wavesurferWave.getCurrentTime();
			if (currentTime >= this.wavesurferWave.getDuration() - 0.2) {
				this.wavesurferWave.seekTo(0);
				this.elapsedMss = 0; // Reset elapsed time when starting from end
			} else if (currentTime < 0.2) {
				this.elapsedMss = 0; // Reset elapsed time when starting near beginning
			}
			this.startTimerVal();

			// Reset wave to start if it's at the end
			if (
				this.wavesurferWave.getCurrentTime() >=
				this.wavesurferWave.getDuration() - 0.2
			) {
				this.wavesurferWave.seekTo(0);
			}

			// Start both video and audio playback
			this.wavesurferWave.play();

			// When audio finishes → stop both
			this.wavesurferWave.once("finish", () => {
				this.isPlayingAudio = false;
				this.wavesurferWave.stop();
				this.stopTimerVal();
				this.elapsedMss = this.finalRecordedMss;
			});

		},
		async loadS3Audio(url) {
			try {
				const res = await fetch(url, {
					mode: "cors"
				});
				if (!res.ok) throw new Error(`HTTP ${res.status}`);
				const blob = await res.blob();
				const objectUrl = URL.createObjectURL(blob);
				return objectUrl;
			} catch (e) {
				console.error("Error loading S3 audio:", e);
			}
		},
		async initWaveSurferForS3(data) {
			
			if (this.wavesurferWave) {
				this.wavesurferWave.destroy();
			}
            
			this.wavesurferWave = WaveSurfer.create({
				container: this.$refs.waveformaudio,
				waveColor: "#bfcde0",
				progressColor: "#1a5fad",
				cursorWidth: 0,
				cursorColor: "#333",
				barWidth: 2,
				height: 30,
				barGap: 2, // spacing between bars
				barRadius: 2,
				responsive: true,
			});
            const sampleBlob = await this.loadSampleWaveData();
            const sampleURL = URL.createObjectURL(sampleBlob);
            await this.wavesurferWave.load(sampleURL);
            let blobData = await this.loadS3Audio(this.audioLinkVal);
			await this.wavesurferWave.load(blobData);
            this.wavesurferWave.once('ready', () => {
                this.wavesurferWave.drawBuffer();
            });
			this.wavesurferWave.on('interaction', () => {
				const progress = this.wavesurferWave.getCurrentTime() / this.wavesurferWave.getDuration();
				this.handleWaveSurferSeekAudio(progress);	
			});
			this.wavesurferWave.on("play", () => (this.isPlayingAudio = true));
			this.wavesurferWave.on("pause", () => (this.isPlayingAudio = false));
			this.wavesurferWave.on(
				"finish",
				() => {
                this.isPlayingAudio = false;
				this.wavesurferWave.seekTo(0);
				this.elapsedMss = data.answer.audioDurationInSec * 1000;
		});
		},
		handleWaveSurferSeekAudio(progress) {
			this.elapsedMss = progress * this.wavesurferWave.getDuration() * 1000;
			
			// Resync timerVal start in playback mode
			if (this.isPlayingAudio) {
			this.stopTimerVal();
			const startReference = Date.now() - this.elapsedMss;
			this.timerVal = setInterval(() => {
				this.elapsedMss = Date.now() - startReference;
			}, 200);
			}
		},
		async getS3Link(link, type) {
			try {
				const res = await getS3Link({
					path: link,
					type: type
				});
				if (res.status == 200) {
					const linkVar = res.data.data.url;
					return linkVar;
				} else return null;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
    }
}